import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "./controllers";

ActiveStorage.start();

document.body.classList.add("group", "js");
